/**
 * The four things every list in Tarifs et abonnements has to be able to say:
 * it is loading, it failed, it refreshed badly, and what the last write did.
 * An empty list and a failed read never look the same.
 */
import { t } from "../../i18n";
import { ErrorNotice } from "../../shell/ErrorNotice";

export function LoadingCard({ text }: { text: string }) {
  return (
    <div className="card">
      <div className="empty" role="status">
        <span className="spinner" aria-hidden="true" />
        <span>{text}</span>
      </div>
    </div>
  );
}

export function FailedCard({ text, error, onRetry }: { text: string; error: unknown; onRetry: () => void }) {
  return (
    <div className="card">
      <div className="audit-error">
        <p className="foot">{text}</p>
        <ErrorNotice error={error} />
        <div>
          <button className="btn primary" type="button" onClick={onRetry}>
            {t("audit.retry")}
          </button>
        </div>
      </div>
    </div>
  );
}

/** A read that failed while something older is still on screen: say it is old. */
export function RefreshBanner({ show, onRetry }: { show: boolean; onRetry: () => void }) {
  if (!show) return null;
  return (
    <div className="banner bad" role="alert">
      <span>{t("billing.refreshFailed")}</span>
      <button className="btn" type="button" onClick={onRetry}>
        {t("audit.retry")}
      </button>
    </div>
  );
}
